import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3 6.386c0-.484.345-.877.771-.877h2.665c.529-.016.996-.399 1.176-.965l.03-.1.115-.391c.07-.24.131-.45.217-.637.338-.739.964-1.252 1.687-1.383.184-.033.378-.033.6-.033h3.478c.223 0 .417 0 .6.033.723.131 1.35.644 1.687 1.383.086.187.147.396.218.637l.114.391.03.1c.18.566.74.95 1.27.965h2.57c.427 0 .772.393.772.877s-.345.877-.771.877H3.77C3.345 7.263 3 6.87 3 6.386"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.596 22h.808c2.783 0 4.174 0 5.08-.886.904-.886.996-2.339 1.181-5.245l.267-4.188c.1-1.577.15-2.366-.303-2.865-.454-.5-1.22-.5-2.753-.5H8.124c-1.533 0-2.3 0-2.753.5s-.404 1.288-.303 2.865l.267 4.188c.185 2.906.277 4.36 1.182 5.245.905.886 2.296.886 5.079.886m-1.35-9.811c-.04-.434-.408-.75-.82-.707-.413.043-.713.43-.672.864l.5 5.263c.04.434.408.75.82.707.413-.043.713-.43.672-.864zm4.329-.707c.412.043.713.43.671.864l-.5 5.263c-.04.434-.409.75-.82.707-.413-.043-.713-.43-.672-.864l.5-5.263c.04-.434.409-.75.82-.707",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }